module.exports = __webpack_public_path__ + "media/images/backgrounds/angle-bottom-left-1da3b74a31a31da3648aacbfd81f73fb.svg";